import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router";
import InscricaoService from "../../services/Inscricoes/InscricaoService";
import { CheckCircle2, AlertCircle, FileText, Home, Loader2 } from "lucide-react";
import { Button } from "../../components/ui";

function SucessoPay() {
    const location = useLocation();
    const [statusEnvio, setStatusEnvio] = useState('processando');
    const [mensagemApi, setMensagemApi] = useState(null);
    const [numCorredor, setNumCorredor] = useState(null);
    const [nomeCorrida, setNomeCorrida] = useState(null);
    const [orderInfo, setOrderInfo] = useState(null);

    useEffect(() => {
        const processarPagamento = async () => {
            const params = new URLSearchParams(location.search);
            const dadosDoRedirect = {};

            for (const [key, value] of params.entries()) {
                dadosDoRedirect[key] = decodeURIComponent(value);
            }

            const directId = dadosDoRedirect.id || dadosDoRedirect.inscricao_id || sessionStorage.getItem('brv-id-inscricao');

            // Caso de Inscrição Gratuita ou confirmação direta por ID
            if (dadosDoRedirect.id || dadosDoRedirect.inscricao_id) {
                try {
                    if (directId) {
                        const service = new InscricaoService();
                        const res = await service.getInscricaoById(directId);
                        if (res && res.ok) {
                            const data = await res.json();
                            setStatusEnvio('sucesso');
                            setNumCorredor(data.num_corredor || data.numero_peito || data.numero_corredor || null);
                            setNomeCorrida(data.nome_corrida || data.corrida?.nome_corrida || null);
                            setOrderInfo(directId);
                            setMensagemApi('Sua inscrição foi confirmada com sucesso!');
                            return;
                        }

                        const userId = sessionStorage.getItem('brv-user-id');
                        if (userId) {
                            const resUser = await service.getCorridasAtuaisUsuario(userId);
                            if (resUser && resUser.ok) {
                                const inscricoes = await resUser.json();
                                if (Array.isArray(inscricoes)) {
                                    const found = inscricoes.find(i =>
                                        String(i.id) === String(directId) ||
                                        i.id_grupo_pagamento === directId ||
                                        i.id_requisicao === directId
                                    );
                                    if (found) {
                                        setStatusEnvio('sucesso');
                                        setNumCorredor(found.num_corredor || found.numero_peito || null);
                                        setNomeCorrida(found.nome_corrida || null);
                                        setOrderInfo(directId);
                                        setMensagemApi('Sua inscrição foi confirmada com sucesso!');
                                        return;
                                    }
                                }
                            }
                        }
                    }

                    setStatusEnvio('sucesso');
                    setOrderInfo(directId);
                    setMensagemApi('Sua inscrição foi confirmada com sucesso!');
                    return;
                } catch (err) {
                    console.warn("Erro ao buscar dados da inscrição gratuita:", err);
                    setStatusEnvio('sucesso');
                    setMensagemApi('Sua inscrição foi confirmada com sucesso!');
                    return;
                }
            }

            if (Object.keys(dadosDoRedirect).length === 0) {
                setStatusEnvio('erro');
                setMensagemApi('Nenhum parâmetro de confirmação encontrado.');
                return;
            }

            const realStatus = dadosDoRedirect.collection_status || dadosDoRedirect.status;
            if (realStatus === 'rejected') {
                window.location.href = `/pagamento/falha${location.search}`;
                return;
            }
            if (realStatus === 'in_process' || realStatus === 'pending') {
                window.location.href = `/pagamento/pendente${location.search}`;
                return;
            }

            try {
                const hoje = new Date();
                const year = hoje.getFullYear();
                const month = String(hoje.getMonth() + 1).padStart(2, '0');
                const day = String(hoje.getDate()).padStart(2, '0');
                const dataFormatada = `${year}-${month}-${day}`;

                const data = {
                    status: "Inscrito",
                    data_pagamento: dataFormatada,
                    uuid_transacao: dadosDoRedirect.payment_id || dadosDoRedirect.collection_id || dadosDoRedirect.preference_id,
                    metodo_pagamento: dadosDoRedirect.payment_type,
                    id_corrida: sessionStorage.getItem('brv-id-corrida'),
                };

                const service = new InscricaoService();
                const idRef = dadosDoRedirect.id_requisicao || sessionStorage.getItem('brv-id-inscricao');

                // Se idRef for um UUID (ex: id_grupo_pagamento ou id_requisicao de 3DS/Lote),
                // a confirmação ocorre via webhook no backend; consultamos as inscrições do usuário.
                const isUuidRef = idRef && String(idRef).includes('-');
                if (isUuidRef) {
                    const userId = sessionStorage.getItem('brv-user-id');
                    if (userId) {
                        const resUser = await service.getCorridasAtuaisUsuario(userId);
                        if (resUser && resUser.ok) {
                            const inscricoes = await resUser.json();
                            if (Array.isArray(inscricoes)) {
                                const matching = inscricoes.filter(i =>
                                    i.id_grupo_pagamento === idRef ||
                                    i.id_requisicao === idRef
                                );
                                if (matching.length > 0) {
                                    setStatusEnvio('sucesso');
                                    setNumCorredor(matching[0].num_corredor || matching[0].numero_peito || null);
                                    setNomeCorrida(matching[0].nome_corrida || null);
                                    setOrderInfo(idRef);
                                    setMensagemApi(
                                        matching.length > 1
                                            ? `Suas ${matching.length} inscrições foram confirmadas! Os comprovantes com QR Code foram enviados por e-mail.`
                                            : 'Sua inscrição foi confirmada! O comprovante com QR Code foi enviado por e-mail.'
                                    );
                                    return;
                                }
                            }
                        }
                    }
                    setStatusEnvio('sucesso');
                    setOrderInfo(idRef);
                    setMensagemApi('Pagamento processado! Assim que confirmado, você receberá o comprovante por e-mail.');
                    return;
                }

                const response = await service.updateInscricao(JSON.stringify(data), idRef);

                if (response.ok) {
                    const resultado = await response.json();
                    setStatusEnvio('sucesso');
                    setNumCorredor(resultado.num_corredor || resultado.numero_peito || resultado.inscricao?.num_corredor || null);
                    setNomeCorrida(resultado.nome_corrida || resultado.inscricao?.nome_corrida || null);
                    setOrderInfo(dadosDoRedirect.merchant_order_id || dadosDoRedirect.id || idRef);
                    setMensagemApi(resultado.mensagem || 'Sua inscrição foi confirmada! O comprovante foi enviado para o seu e-mail.');
                } else {
                    const erro = await response.json();
                    setStatusEnvio('erro');
                    setMensagemApi(erro.mensagem || 'O servidor respondeu com um erro.');
                }
            } catch (error) {
                setStatusEnvio('erro');
                setMensagemApi('Falha ao comunicar com o servidor. Verifique a conexão.');
            }
        };

        processarPagamento();
    }, [location.search]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-urb-dark px-4 py-12">
            <div className="max-w-md w-full bg-urb-card border border-urb-border rounded-2xl p-8 shadow-2xl text-center">
                {statusEnvio === 'processando' && (
                    <div className="flex flex-col items-center gap-4 py-8">
                        <Loader2 className="w-12 h-12 text-blue-400 animate-spin" />
                        <h2 className="text-xl font-bold text-white">Processando Inscrição...</h2>
                        <p className="text-sm text-slate-400">
                            Aguarde, estamos confirmando os dados com nosso servidor.
                        </p>
                    </div>
                )}

                {statusEnvio === 'sucesso' && (
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-urb-primary/10 border border-urb-primary/30 flex items-center justify-center text-urb-primary shadow-neon">
                            <CheckCircle2 className="w-12 h-12" />
                        </div>

                        <h2 className="text-2xl font-extrabold text-white mt-1">Inscrição Confirmada!</h2>
                        <p className="text-sm text-urb-primary font-medium">
                            {mensagemApi || 'Seu pagamento e inscrição foram concluídos com sucesso!'}
                        </p>

                        {nomeCorrida && (
                            <div className="text-sm font-semibold text-slate-200">
                                {nomeCorrida}
                            </div>
                        )}

                        {numCorredor && (
                            <div className="flex flex-col items-center justify-center p-4 my-1 rounded-xl bg-urb-primary/10 border border-urb-primary/40 w-full">
                                <span className="text-xs text-slate-300 font-semibold tracking-wider uppercase">Número do Corredor</span>
                                <span className="text-4xl font-black text-urb-primary font-mono tracking-widest mt-1">
                                    {numCorredor}
                                </span>
                            </div>
                        )}

                        {orderInfo && (
                            <div className="text-xs text-slate-400">
                                Inscrição / Pedido Ref: <strong className="text-slate-300 font-mono">{orderInfo}</strong>
                            </div>
                        )}

                        <div className="flex flex-col sm:flex-row gap-3 w-full mt-3">
                            <Link to="/minhas-corridas" className="flex-1">
                                <Button className="w-full flex items-center justify-center gap-2 font-bold py-3 shadow-neon">
                                    <FileText className="w-4 h-4" />
                                    Minhas Corridas
                                </Button>
                            </Link>
                            <Link to="/" className="flex-1">
                                <Button variant="secondary" className="w-full flex items-center justify-center gap-2 font-bold py-3">
                                    <Home className="w-4 h-4" />
                                    Início
                                </Button>
                            </Link>
                        </div>
                    </div>
                )}

                {statusEnvio === 'erro' && (
                    <div className="flex flex-col items-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-red-500/10 border border-red-500/30 flex items-center justify-center text-red-500">
                            <AlertCircle className="w-10 h-10" />
                        </div>
                        <h2 className="text-2xl font-bold text-white">Erro ao Processar</h2>
                        <p className="text-sm text-slate-300">{mensagemApi}</p>
                        <p className="text-xs text-slate-400">Por favor, entre em contato com nosso suporte.</p>

                        <Link to="/home" className="w-full mt-2">
                            <Button variant="secondary" className="w-full py-3">
                                Voltar para o Início
                            </Button>
                        </Link>
                    </div>
                )}
            </div>
        </div>
    );
}

export default SucessoPay;